import React, { useEffect, useState } from "react";

const COOKIE_NAME = "cookieConsent";

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

// Extend the global window object types
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

function loadAnalytics() {
  if (window.gtag) return; // Already loaded

  const script = document.createElement("script");
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-EHS4K6VQ04";
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer!.push(args);
  }

  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", "G-EHS4K6VQ04");
}

const CookieConsentBanner: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = getCookie(COOKIE_NAME);
    if (!consent) setShowBanner(true);
    else if (consent === "true") loadAnalytics();
  }, []);

  const accept = () => {
    document.cookie = `${COOKIE_NAME}=true; path=/; max-age=31536000`;
    loadAnalytics();
    setShowBanner(false);
  };

  const reject = () => {
    document.cookie = `${COOKIE_NAME}=false; path=/; max-age=31536000`;
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 w-full bg-gray-900 text-white p-4 z-50 flex justify-between items-center">
      <p className="text-sm">
        We use cookies for analytics.{" "}
        <a href="/cookie-policy" className="underline">
          Learn more
        </a>.
      </p>
      <div className="space-x-2">
        <button
          onClick={accept}
          className="bg-green-500 hover:bg-green-600 px-4 py-2 rounded"
        >
          Accept
        </button>
        <button
          onClick={reject}
          className="bg-red-500 hover:bg-red-600 px-4 py-2 rounded"
        >
          Reject
        </button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
